export const iconFontAwesomeArrowsArrowsToDot = (
	<i className="fa-solid fa-arrows-to-dot"></i>
);
